export var Name = 'cancel-backorder-demand';
export var CancelBackorderDemandEvent = Name;